import { useEffect, useState } from 'react';

/**
 * 터치로 조작하는 기기인지.
 *
 * 화면 폭으로 판단하지 않는다. 폭은 배치(layout)를 정하고, 조작 방식은
 * 포인터 종류가 정한다 — 좁은 데스크톱 창에는 마우스가 있고, 넓은
 * 태블릿에는 없다. 둘을 섞으면 창을 줄인 데스크톱에 조이스틱이 뜨고
 * 태블릿에서는 호버로만 열리는 버튼이 영영 닿지 않는다.
 *
 * `hover: none`과 `pointer: coarse`를 함께 본다. 마우스가 붙은 터치
 * 노트북은 hover가 되므로 데스크톱으로 취급한다 — 그쪽이 맞다.
 */
const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

export function isTouchDevice(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(TOUCH_QUERY).matches;
}

export function useIsTouch(): boolean {
  const [touch, setTouch] = useState(isTouchDevice);

  useEffect(() => {
    // 외장 마우스를 붙이거나 떼면 바뀐다. 태블릿에서 실제로 일어난다.
    const query = window.matchMedia(TOUCH_QUERY);
    const onChange = () => setTouch(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return touch;
}
